import { BordOneToneIcon, NudosButton } from 'components/NudosComponents';
import { useHistory } from 'react-router-dom';
import { IlogisticServiceDetails } from 'types/services';
import {
  SERVICE_SUMMARY_VARIANT_ICON,
  ServiceSummaryVariantIconColor,
  SERVICE_SUMMARY_VARIANT_TEXT,
  SERVICE_SUMMARY_VARIANTS,
  IEditPricesPermissions
} from 'components/SummaryBanner/SummaryBanner.types';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import './GenerateQuote.scss';

interface IGenerateQuoteProps {
  id?: number;
  LSData?: IlogisticServiceDetails;
  editPricesPermissions?: IEditPricesPermissions;
}

const GenerateQuote = ({ id, LSData, editPricesPermissions }: IGenerateQuoteProps) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/logistic-service/edit/${id}`, { state: { LSData } });
  };

  return (
    <div className="serviceSummaryBanner generateQuote">
      <BordOneToneIcon variant="document" customWidth="48px" className="documentIcon" />{' '}
      <p className="description">
        En este espacio podrás consultar el resumen del servicio y la cotización una vez lo crees
      </p>
      {editPricesPermissions?.read && (
        <NudosButton
          buttonText="Generar cotización"
          colorPalette="secondary"
          buttonIcon={<BordOneToneIcon variant="plus" customWidth="12px" stroke="black" />}
          customClassName="generateQuoteButton"
          handleClick={handleClick}
          isButtonDisabled={!editPricesPermissions?.edit}
        />
      )}
      <div className="quoteStatusContainer">
        <div className="quoteStatus">
          Estado de la cotización:{' '}
          <span className="quoteStatusText">
            {SERVICE_SUMMARY_VARIANT_TEXT[SERVICE_SUMMARY_VARIANTS.TO_QUOTE]}
            <BordOneToneIcon
              variant={SERVICE_SUMMARY_VARIANT_ICON[SERVICE_SUMMARY_VARIANTS.TO_QUOTE] as TbordOneToneIcon}
              customWidth="10px"
              className="quoteStatusIcon"
              stroke={ServiceSummaryVariantIconColor[SERVICE_SUMMARY_VARIANTS.TO_QUOTE]}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default GenerateQuote;
